import styled from "styled-components";
import {devices, sizes} from "../../utils/styled/_variables.styled";

const ImageBar = styled.section`
	background: transparent;
	display: flex;
	justify-content: center;
	align-items: center;

	height: ${props => props.containerHeight + "px" ? props.containerHeight : 'unset'};

	@media ${devices.mobile} {
		height: unset;
	}

	&.setMinHeight {
		min-height: 50px;
	}

	&.justify-start {
		justify-content: flex-start;
	}

	&.justify-center {
		justify-content: center;
	}

	&.justify-end {
		justify-content: flex-end;
	}

	&.align-start {
		align-items: flex-start;
	}

	&.align-center {
		align-items: center;
	}

	&.align-end {
		align-items: flex-end;
	}

	.image {
		&__link {
			text-decoration: none;
		}

		&__content {
			max-width: ${props => props.isFullWidth ? 'none' : `${sizes.desktop - 1}px`};
			width: ${props => props.isFullWidth ? '100%' : `auto`};

			position: relative;
		}

		&__upload {
			line-height: 0;

			&__shadow {
				line-height: 0;
				position: relative;

				&::after {
					pointer-events: none;
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: ${props => props.imageWidth ? props.imageWidth + "px" : '100%'};
					height: 100%;
					border-radius: 8px;
					background-image: ${props => {
						switch (props.shadow) {
							case 'top':
								return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
							case 'bottom':
								return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
							case 'both':
								return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
							default:
								return '';
						}
					}
					};
				}
			}

			max-width: 100%;
			height: auto;
			border-radius: 8px;
			width: ${props => props.isFullWidth ? '100%' : `auto`};
			@media ${devices.mobile} {
				max-width: 100%;
			}
		}

		&__text {
			font-size: 19px;
			margin-top: 12px;
		}
	}
`;

export {ImageBar};
